<template>
    <div class="video-js-wrapper" :class="{ '-hidePlayButton' : isHidePlayButton }">
        <video ref="videoPlayer" class="video-js" @loadeddata="loadedData" :playsinline="playsinline"></video>
    </div>
</template>

<script>
    import videojs from 'video.js';

    export default {
        name: "VideoPlayer",
        props: {
            options: {
                type: Object,
                default() {
                    return {};
                }
            },
            playsinline: {
                type: Boolean,
                required: false,
                default: false
            },
            isPlayButton: {
                type: Boolean,
                required: false,
                default: true
            },
            imagePath: {
                type: String,
                required: false,
            },
            mediaId: {
                type: String,
                required: false,
                default: ''
            }
        },
        data: function () {
            return {
                isHidePlayButton: true,
                posterImage: '',
                thumbnailUrl: `${process.env.VUE_APP_THUMBNAIL}`,
            };
        },
        mounted: function () {
            this.player = videojs(this.$refs.videoPlayer, this.options, function onPlayerReady() {
            });

            if (!this.options.autoplay) this.isHidePlayButton = false;

            const video = document.querySelectorAll('.vjs-tech').item(0);

            video.addEventListener('loadeddata', () => {
                this.$emit('video-is-loaded');
                if (this.isPlayButton) this.hidePlayButton();
            });

            video.addEventListener('play', () => {
                this.$emit('video-is-played');
                if (this.isPlayButton) this.hidePlayButton();
            });

            video.addEventListener('pause', () => {
                this.$emit('video-is-paused');
                if (this.isPlayButton) this.displayPlayButton();
            });
            this.setPosterImage();

            if (this.mediaId) {
                this.fetchM3u8();
            }
        },
        beforeDestroy: function () {
            if (this.player) {
                this.player.dispose()
            }
        },
        methods: {
            loadedData: function () {
                this.$emit('video-has-loaded');
            },
            playVideo: function () {
                this.player.play();
                this.hidePlayButton();
            },
            pauseVideo: function () {
                this.player.pause();
                this.displayPlayButton();
            },
            getVideoPaused: function () {
                return this.player.paused();
            },
            displayPlayButton: function () {
                this.isHidePlayButton = false;
            },
            hidePlayButton: function () {
                this.isHidePlayButton = true;
            },
            setPosterImage() {
                if (this.imagePath) {
                    this.player.poster(this.checkWebPSupport()
                        ? `${this.thumbnailUrl}/webp/${this.imagePath}.webp`
                        : `${this.thumbnailUrl}/images/${this.imagePath}.jpg`
                    );
                }
            },
            checkWebPSupport() {
                const canvas = document.createElement('canvas');
                return canvas.toDataURL('image/webp').indexOf('data:image/webp') === 0;
            },
            async fetchM3u8() {
                try {
                    const response = await window.axios.get(this.routes.streaks(this.mediaId));
                    if (response.data) {
                        this.player.src({
                            src: response.data.sources[0].src,
                            type: 'application/x-mpegURL'
                        });
                    }
                } catch (e) {
                    // eslint-disable-next-line no-console
                    console.error('Failed to fetch m3u8 from local proxy', e);
                }
            },
        },
        watch: {
            mediaId: function (newVal) {
                if (newVal) {
                    this.fetchM3u8();
                }
            }
        }
    }
</script>

<style src="./VideoPlayer.scss" lang="scss" />
